import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { APP_VERSION } from './core/constants/app-version';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.html',
  styleUrl: './app.css',
})
export class App {
  readonly appVersion = APP_VERSION;
}
